import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { InvitationState, Name, UserRole } from '../../types/Users';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/me', 'get'>;

type Result = {
  id: number;
  email: string;
  name: Name;
  role: UserRole;
  inviteState: InvitationState;
  organization: {
    id: number;
    name: string;
    /**
     * The organization's tenant. The media library API takes it as its `companyId` route segment
     * and validates it against the caller, so the page cannot open the library without it.
     */
    tenantGuid: string;
  };
};

export const getMeFactory = (apiClient: ApiClient) => {
  const getMe = async () => {
    const response = await apiClient['/api/me'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      email: response.email,
      name: {
        firstName: response.name.firstName ?? '',
        lastName: response.name.lastName ?? '',
      },
      role: response.role,
      inviteState: response.inviteState,
      organization: {
        id: response.organization.id,
        name: response.organization.name,
        tenantGuid: response.organization.tenantGuid,
      },
    };
  };

  return getMe;
};
